'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeight = getHeight;
exports.getPositionFromTop = getPositionFromTop;
exports.getScrollTop = getScrollTop;
/**
 * Gets the height of the element, accounting for API differences between
 * `window` and other DOM elements.
 */
function getHeight(element) {
  return element === window ? window.innerHeight : element.getBoundingClientRect().height;
}

/**
 * Gets the vertical position of an element within its scroll container.
 * Elements that have been “scrolled past” return negative values.
 * Handles edge-case where a user is navigating back (history) from an already-scrolled page.
 * In this case the body’s top position will be a negative number and this element’s top will be increased (by that amount).
 */
function getPositionFromTop(element, container) {
  var offset = container === window ? 0 : getScrollTop(container);
  var containerElement = container === window ? document.documentElement : container;
  return element.getBoundingClientRect().top + offset - containerElement.getBoundingClientRect().top;
}

/**
 * Gets the vertical scroll amount of the element, accounting for IE compatibility
 * and API differences between `window` and other DOM elements.
 */
function getScrollTop(element) {
  if (element === window) {
    return 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop;
  } else {
    return element.scrollTop;
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/dist/commonjs/WindowScroller/utils/dimensions.js
// module id = 1991
// module chunks = 0